<template>
  <div class="container-fluid">
    <div class="row">
      <div
        class="col-lg-12 justify-content-center text-center d-none d-lg-flex"
      >
        <img
          src="@/assets/404_page_notfound_frontend_bangunan.svg"
          alt="404 not found"
          class="w-50"
        />
      </div>
      <div
        class="col-lg-12 justify-content-center text-center d-lg-none d-block"
      >
        <img
          src="@/assets/404_page_notfound_frontend_bangunan.svg"
          alt="404 not found"
          class="w-100"
        />
      </div>
    </div>
  </div>
</template>